import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { PETITIONER_AND_RESPONDENT_TYPES } from "@/lib/constants";
import styles from "./PetitionerRespondentToggle.module.scss";

const PETITIONER_RESPONDENT_OPTIONS = [
  {
    name: PETITIONER_AND_RESPONDENT_TYPES.PLAINTIFF_AND_DEFENDANT,
    value: false,
  },
  {
    name: PETITIONER_AND_RESPONDENT_TYPES.PETITIONER_AND_RESPONDENT,
    value: true,
  },
] as const;

interface PetitionerRespondentToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
  idPrefix?: string;
}

export default function PetitionerRespondentToggle({
  value,
  onChange,
  idPrefix = "toggle-petitioner-respondent",
}: PetitionerRespondentToggleProps) {
  return (
    <div className={styles.togglePetitionerRespondentContainer}>
      <ButtonGroup className={styles.bpToggleTxtSwitch}>
        {PETITIONER_RESPONDENT_OPTIONS.map((type, idx) => (
          <ToggleButton
            key={idx}
            id={`${idPrefix}-${type.value}`}
            type="radio"
            name={idPrefix}
            className={value === type.value ? styles.btnChecked : ""}
            value={type.value ? "1" : "2"}
            checked={value === type.value}
            onChange={() => onChange(type.value)}
          >
            {type.name}
          </ToggleButton>
        ))}
      </ButtonGroup>
    </div>
  );
}
